<div id="partnerContentSection" class="fade show partner_content">
  <div id="partnerData" class="view_partner_data">
    <div id="partnerSectionTitleBar" class="title_bar">
      <img class="page_back_icon" alt="go back" (click)="goBack()" />
      <span class="title">{{attractorLoopName}}</span>
    </div>

    <!-- Section 1 - Model SKU Info -->
    <section>
      <div id="skuSectionHeader" class="section_header">
        <img class="sku" alt="sku" />
        <span i18n="@@view-attract-admin.header.Model-SKU-Info">MODEL SKU INFO</span>
      </div>
      <div id="skuInfoSectionBody" class="section_body model_info_section">
        <div id="skuModelInfoGrp" class="info_group">
          <label><span i18n="@@view-attract-admin.systemId">System ID</span></label>
          <ul [ngClass]="systemIdSize > 7 ? 'systemId_list' : ''">
            <ng-container *ngFor="let item of systemID">
              <li *ngIf='item.length>20;else elseBlock' [ngbTooltip]='item'>
                {{(item | slice:0:17 )+ '...'}}
              </li>
              <ng-template #elseBlock>
                <li>{{item}}</li>
              </ng-template>
            </ng-container>
          </ul>
        </div>
        <div id="publishInfo" class="info_group">
          <div id="publishDateTime" *ngIf="publishDate?.length">
            <label><span i18n="@@segments.expanded-segment.publish-date">Publishing Date and Time</span></label>
            <div>
              {{publishDate | dateFormat: "24hrP" }}
            </div>
          </div>
          <div id="expiryDateTime" class="mt-2" *ngIf="expiryDate?.length">
            <label><span i18n="@@segments.expanded-segment.expire-date">Expiration Date and Time</span></label>
            <div>
              {{expiryDate | dateFormat: "24hrP" }}
            </div>
          </div>
        </div>
        <div id="locationHeaderList" class="loc-container row">
          <div id="locationHeading" class="col-5 box-align">
            <div> <span class="location-heading"
                i18n="@@create-attractor-loop-oem.location-heading.attractloop-video-will-be-shown"><strong>Attract loop video
                will be shown in these locations</strong></span></div>
              <div id="locationDropList" class="location1 list-container">
                <ul id="selectedLocations" class="selection-list">
                  <li *ngFor="let location of selectedLocations">{{ location }}</li>
                </ul>
              </div>
          </div>
          <div id="locationHeading" class="col-5 box-align">
            <div><span class="location-heading "
                i18n="@@create-attractor-loop-oem.location-header.attract-loop-not-shown"><strong>Attract Loop video will NOT be
                shown in these locations</strong></span></div>
            <div id="location3" class="location3">
              <div id="location3List" class="list-container">
                <div class="nolocation" *ngIf="excludedLocations.length === 0"><span>No location has been added</span></div>
                <ul id="selectedLocations" class="selection-list">
                  <li *ngFor="let excludedlocation of excludedLocations">{{ excludedlocation }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section>
      <div id="attractAdminSection" class="section_header">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M4.0005 5.25C3.033 5.25 2.25 6.033 2.25 7.0005V16.9995C2.25 17.967 3.033 18.75 4.0005 18.75H13.9995C14.967 18.75 15.75 17.967 15.75 16.9995V7.0005C15.75 6.033 14.967 5.25 13.9995 5.25H4.0005ZM0.75 7.0005C0.75 5.205 2.205 3.75 4.0005 3.75H13.9995C15.795 3.75 17.25 5.205 17.25 7.0005V16.9995C17.25 18.795 15.795 20.25 13.9995 20.25H4.0005C3.13841 20.25 2.31164 19.9075 1.70205 19.298C1.09246 18.6884 0.75 17.8616 0.75 16.9995V7.0005Z" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M16.8745 8.4747L21.0265 6.0672C21.0979 6.0242 21.1793 6.00064 21.2625 5.99885C21.3458 5.99707 21.4281 6.01712 21.5012 6.05702C21.5743 6.09692 21.6357 6.15527 21.6793 6.22627C21.7229 6.29727 21.7471 6.37843 21.7495 6.4617V17.5377C21.7495 17.8797 21.3595 18.1272 21.0265 17.9337L16.876 15.5262L16.123 16.8237L20.2735 19.2312C21.562 19.9782 23.2495 19.0887 23.2495 17.5377V6.4617C23.2495 4.9122 21.562 4.0227 20.2735 4.7697L16.1245 7.1772L16.8775 8.4747H16.8745Z" />
        </svg>
        <div id="attractAdminHeaderLoopVideo" class="ml-2"><span i18n = "@@view-attract-admin.section-header.loop-video">ATTRACT LOOP VIDEO</span></div>
      </div>
      <div id="attractAdminSectionBody" class="section_body">
        <div id="videoInfo" class="info_group">
          <ng-container>
            <video [src]="downloadURl" controls></video>
          </ng-container>
        </div>
      </div>
    </section>

    <!-- Section 5 - Comments -->
    <section *ngIf="hasComments || commentEnabled">
      <div id="commentSectionHeader" class="section_header">
        <img class="chat_quote" alt="provide comments" />
        <span i18n="@@view-attract-admin.comments">COMMENTS</span>
      </div>
      <div id="commentSectionBody" class="section_body">
        <ng-container *ngTemplateOutlet='!commentEnabled?showComments:textArea'></ng-container>
      </div>
    </section>
    <ng-container *ngTemplateOutlet='!commentEnabled?closeEdit:commentApproveReject'></ng-container>
  </div>
</div>
<!-- templates  -->
<ng-template #showComments>
  <div id="showComments" class="comments_provided">
    {{comments}}
  </div>
</ng-template>

<ng-template #textArea>
  <div id="attractAdminTextArea" class="d-block">
    <div id="commentSentToCreator" class="mb-3">
      <span i18n ="@@view-attract-admin.text-box.comments-sent-to-creator">Your comments will be sent to the creator of this Attract Loop Video once returned.</span>
    </div>
    <div id="reviewCommentText" class="form-group">
      <label><span i18n = "@@view-attract-admin.review-comment.comments">Comments</span></label>
      <textarea #textAreaInput (input)='checkForInput($event.target.value)' [attr.maxlength]='250' class="form-control" rows="3"
        [placeholder]="commentsBox"></textarea>
    </div>
  </div>
</ng-template>

<ng-template #commentApproveReject>
  <div id="rejectApproveButtonWrapper" class="button_wrapper">
    <button [disabled]='!inputComments' (click)='openPopup(reviewPopup,"returned")'
      class="btn btn-outline-danger btn-lg left_icon_btn">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 22.5C14.7848 22.5 17.4555 21.3938 19.4246 19.4246C21.3938 17.4555 22.5 14.7848 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12C1.5 14.7848 2.60625 17.4555 4.57538 19.4246C6.54451 21.3938 9.21523 22.5 12 22.5ZM12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24Z" />
          <path
            d="M10.5029 16.4997C10.5029 16.3027 10.5417 16.1077 10.6171 15.9257C10.6925 15.7437 10.803 15.5783 10.9423 15.439C11.0816 15.2997 11.2469 15.1892 11.4289 15.1139C11.6109 15.0385 11.8059 14.9997 12.0029 14.9997C12.1999 14.9997 12.395 15.0385 12.577 15.1139C12.7589 15.1892 12.9243 15.2997 13.0636 15.439C13.2029 15.5783 13.3134 15.7437 13.3887 15.9257C13.4641 16.1077 13.5029 16.3027 13.5029 16.4997C13.5029 16.8975 13.3449 17.279 13.0636 17.5603C12.7823 17.8417 12.4008 17.9997 12.0029 17.9997C11.6051 17.9997 11.2236 17.8417 10.9423 17.5603C10.661 17.279 10.5029 16.8975 10.5029 16.4997ZM10.6499 7.49219C10.63 7.30295 10.65 7.11163 10.7087 6.93063C10.7675 6.74963 10.8636 6.58301 10.9909 6.44157C11.1182 6.30013 11.2738 6.18703 11.4476 6.10961C11.6215 6.03219 11.8096 5.99219 11.9999 5.99219C12.1902 5.99219 12.3784 6.03219 12.5522 6.10961C12.726 6.18703 12.8817 6.30013 13.009 6.44157C13.1362 6.58301 13.2324 6.74963 13.2911 6.93063C13.3499 7.11163 13.3699 7.30295 13.3499 7.49219L12.8249 12.7527C12.8073 12.9593 12.7127 13.1519 12.56 13.2921C12.4072 13.4324 12.2073 13.5103 11.9999 13.5103C11.7925 13.5103 11.5927 13.4324 11.4399 13.2921C11.2871 13.1519 11.1926 12.9593 11.1749 12.7527L10.6499 7.49219Z" />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span i18n = "@@view-attract-admin.return-with-comments.text">Return with Comments</span>
    </button>
    <button (click)='openPopup(reviewPopup,"approved")' class="btn btn-outline-success btn-lg left_icon_btn">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M20.781 5.46936C20.8508 5.53903 20.9062 5.6218 20.944 5.71291C20.9818 5.80403 21.0013 5.90171 21.0013 6.00036C21.0013 6.09902 20.9818 6.1967 20.944 6.28781C20.9062 6.37893 20.8508 6.4617 20.781 6.53136L10.281 17.0314C10.2113 17.1012 10.1285 17.1566 10.0374 17.1944C9.9463 17.2322 9.84862 17.2517 9.74997 17.2517C9.65132 17.2517 9.55364 17.2322 9.46252 17.1944C9.3714 17.1566 9.28864 17.1012 9.21897 17.0314L3.96897 11.7814C3.82814 11.6405 3.74902 11.4495 3.74902 11.2504C3.74902 11.0512 3.82814 10.8602 3.96897 10.7194C4.1098 10.5785 4.30081 10.4994 4.49997 10.4994C4.69913 10.4994 4.89014 10.5785 5.03097 10.7194L9.74997 15.4399L19.719 5.46936C19.7886 5.39952 19.8714 5.34411 19.9625 5.3063C20.0536 5.26849 20.1513 5.24902 20.25 5.24902C20.3486 5.24902 20.4463 5.26849 20.5374 5.3063C20.6285 5.34411 20.7113 5.39952 20.781 5.46936Z" />
      </svg>
      <span i18n = "@@view-attract-admin.approve-label">Approve</span>
    </button>
  </div>
</ng-template>

<ng-template #closeEdit>
  <div id="closeButtonWrapper" class="button_wrapper" *ngIf="reviewStatus === 'returned'">
    <button class="btn btn-outline-primary btn-lg" (click)="goBack()"><span i18n="@@view-attract-admin.btn.close">Close</span></button>
    <button class="btn btn-primary btn-lg" (click)="goEdit()"><span i18n="@@view-attract-admin.btn.edit">Edit</span></button>
  </div>
</ng-template>

<!-- changes for IIT3-28 -->
<!-- changes for IIT3-28 -->
<ng-template #reviewPopup let-modal>
  <div id="confirmPopupCard"  [ngClass]="isReturnPopup || (whichPopup === 'approved' && !openPushApproveModal) ? 'confirm-modal' : ''" class="card confirmPopup">
    <div id="reviewPopupModalHeader" class="modal-header">
      <div id="popupModalCloseBtn" (click)="closePopup(modal)" class="close-icon">
        <img src="../../../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="popupModalBody" class="modal-body popup-body" [ngClass]="{'text-center':doneState}">
      <div *ngIf='doneState'>
        <div class="invitesuccess_img_div text-center">
          <span class="invitesuccess_img"></span>
        </div>
        <h2 class="mt-3">
          <span *ngIf='whichPopup !== "approved"'>{{doneRejectLabel}}</span>
          <span *ngIf='whichPopup === "approved" && !openPushApproveModal'>{{attractorLoopName}} {{doneApproveLabel}}</span>
        </h2>
        <div class="card-desc">
          <span *ngIf='whichPopup !== "approved"' i18n = "@@view-attract-admin.card.returend-with-comments">{{attractorLoopName}} has been returned to {{name}} with your
            comments.</span>
          <span *ngIf='whichPopup === "approved" && !openPushApproveModal' i18n = "@@view-attract-admin.card.successfully-approved">You have successfully
            approved {{attractorLoopName}}.</span>
        </div>
        </div>
      <div id="aprroveInfo" *ngIf='!doneState'>
        <h2><span *ngIf="!openPushApproveModal">{{popupTitle}} {{attractorLoopName}}?</span></h2>
        <h2> <span *ngIf="openPushApproveModal" i18n = "@@view-attract-admin.approve-label">Approve {{attractorLoopName}} ?</span></h2>
        <div id="popupModalCardDesc" class="card-desc">
          <span *ngIf='whichPopup !== "approved"' i18n = "@@view-attract-admin.card.will-be-returend-with-comments">{{attractorLoopName}} will be returned with
            comments.</span>
          <span *ngIf='whichPopup === "approved" && openPushApproveModal' i18n="@@view-attract-admin.confirmation-popup.would-you-like-approve-and-push">Would you like to approve and <strong>push</strong> these changes to all devices 
            currently displaying this content?</span>
        </div>
        <div id="approvedPopup" class="card-desc"><span *ngIf='whichPopup === "approved" && openPushApproveModal' i18n="@@view-attract-admin.approved-popup.click-on-approve-but-dont-push">If you click on <strong>“Approve but don’t push updates”</strong>, 
          changes will NOT be pushed to devices in real time but these changes will reflect in packages that are generated post approval.</span></div>
        <div id="bottomCardDesc" class="card-desc card-bottom">
          <span *ngIf='whichPopup === "approved" && openPushApproveModal' i18n="@@view-attract-admin.approve-and-push-popup.click-approve-and-push">If you click on <strong>“Approve and push updates”</strong>, 
            changes will be pushed to devices with internet connectivity that are displaying this content.</span>
        </div>
      </div>
    </div>
    <div id="popupModalCardFooter" *ngIf="!doneState && openPushApproveModal && !isReturnPopup" class="modal-footer card-footer">
      <button type="button" data-inline="true" (click)="approveModal(modal)" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@view-attract-admin.popup-modal-card-footer.click-approve-dont-push-footer">Approve but don’t push updates</span>
      </button>
      <button type="button" data-inline="true" class="btn btn-primary btn-confirm" (click)="approveAndPushModal(modal)">
        <span i18n="@@view-attract-admin.popup-modal-card-footer.click-approve-and-push-footer">Approve and push updates</span>
      </button>
    </div>
    <div id="popupModalCardFooter" *ngIf='!doneState && !openPushApproveModal' class="modal-footer card-footer return-footer">
    <button type="button" (click)="modal.close()" class="btn btn-outline-primary btn-cancel">
      <span i18n="@@view-attract-admin.cancel-btn">Cancel</span></button>
      <button type="button" class="btn btn-primary btn-confirm" (click)="sendMail()">
        {{popupAction}}</button>
    </div>
  </div>
</ng-template>
<!-- confirmation popup for attract loop pushed -->
<div id="confirmationPopupModal" class="container">
  <div id="showConfimationPopup" class="modal-dialog modal-dialog-centered" *ngIf="openModal">
    <div id="modalBackdrop" class="modal-backdrop show"></div>
    <div class="modal" id="myModal">
      <div id="confirmModalDialog" class="modal-dialog">
        <div id="confirmModalContent" class="modal-content">
          <div id="modalcloseIcon" class="close" data-dismiss="modal" (click)="closeModal()">
            <img class="modal-close-icon" alt="close" />
          </div>
          <div id="aprroveCheckCircle" class="modal-body popup-modal" *ngIf="approved">
              <img class="check_circle" alt="check circle" />
            <div id="approveHeading" class="heading"><span i18n="@@view-attract-admin.approve-heading.attractloop-approved">{{attractorLoopName}} Approved</span></div>
            <div id="approveTextBody" class="text-body"><span i18n="@@view-attract-admin.approve-text-body.attractloop-successfully-approved"><p>You have successfully approved {{attractorLoopName}}.</p></span></div>  
        </div>
        <div id="confirmPopupPushUpdates" class="modal-body popup-modal" *ngIf="pushUpdates">
          <img class="check_circle" alt="check circle" />
        <div id="attractorLoopApproved" class="heading"><span i18n="@@view-attract-admin.approve-heading.attractloop-approved">{{attractorLoopName}} Approved</span></div>
        <div id="approvedText" class="text-body">
          <span i18n="@@view-attract-admin.approved-text.attractloop-successfully-approved-and-pushed" *ngIf="devicesCount !== 1">
            <p>You have successfully approved {{attractorLoopName}}. Changes are pushed to {{devicesCount}} devices and these changes will reflect in devices with an active internet connection.</p>
          </span>
          <span i18n="@@view-attract-admin.approved-text.attractloop-successfully-approved-and-pushed-to-one-device" *ngIf="devicesCount === 1">
            <p>You have successfully approved {{attractorLoopName}}. Changes are pushed to {{devicesCount}} device and these changes will reflect in device with an active internet connection.</p>
          </span>
        </div>  
        </div>
      </div>
    </div>
  </div>
</div>
</div>
